import { useEffect } from 'react';

export const Modal = ({ title, isOpen, onClose, children }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal_wrapper">
      <div className="modal-closure" onClick={onClose} />
      <div className="modal-block">
        {title && <div className="contact_step-title">{title}</div>}
        <div className="modal-content">
          {children}
        </div>
        <div className="modal-actions">
          <button className="step-button" onClick={onClose}>Закрыть</button>
        </div>
      </div>
    </div>
  );
}


